<template>
  <MyOrdersScratchcardCard v-bind="data">
    <template #header>
      <MyOrdersScratchcardStatus v-bind="{ status }" :count="data.quantityActive" />
    </template>
  </MyOrdersScratchcardCard>
</template>

<script lang="ts" setup>
import type { ScratchcardOrdersQuery } from '#api/shared/@types/generated/backend/graphql-schema-types'

type MyOrdersScratchcardCardActiveProps = {
  data: ScratchcardOrdersQuery['scratchcardOrders']['scratchcardOrders'][0]
}

const props = defineProps<MyOrdersScratchcardCardActiveProps>()
const status = computed(() => props.data.state)
</script>
